import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AdminGuard, MemberGuard } from './routes/RouteGuards';

// Public Pages & Layout
import PublicLayout from './components/PublicLayout';
import Beranda from './pages/public/Beranda';
import Tentang from './pages/public/Tentang';
import KeanggotaanInfo from './pages/public/KeanggotaanInfo';
import PendaftaranBaru from './pages/public/PendaftaranBaru';
import Direktori from './pages/public/Direktori';
import Login from './pages/public/Login';
import DetailBerita from './pages/public/DetailBerita';

// Member Pages & Layout
import MemberLayout from './components/MemberLayout';
import MemberStatus from './pages/member/MemberStatus';
import DashboardMember from './pages/member/DashboardMember';
import ProfilPesantren from './pages/member/ProfilPesantren';
import UnitUsaha from './pages/member/UnitUsaha';

// Admin Pages & Layout
import AdminLayout from './components/AdminLayout';
import DashboardAdmin from './pages/admin/DashboardAdmin';
import VerifikasiPendaftaran from './pages/admin/VerifikasiPendaftaran';
import ApprovalFinal from './pages/admin/ApprovalFinal';
import MasterData from './pages/admin/MasterData';
import PengurusAdmin from './pages/admin/PengurusAdmin'; // File baru
import BeritaAdmin from './pages/admin/BeritaAdmin';       // File baru
import DokumenAdmin from './pages/admin/DokumenAdmin';     // File baru

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* === AREA PUBLIK === */}
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<Beranda />} />
                        <Route path="/tentang" element={<Tentang />} />
                        <Route path="/keanggotaan" element={<KeanggotaanInfo />} />
                        <Route path="/daftar" element={<PendaftaranBaru />} />
                        <Route path="/direktori" element={<Direktori />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/berita/:id" element={<DetailBerita />} />
                    </Route>

                    {/* === AREA ANGGOTA (PRIVAT) === */}
                    <Route element={<MemberGuard />}>
                        <Route element={<MemberStatus />}>
                            <Route path="/member" element={<MemberLayout />}>
                                <Route index element={<Navigate to="dashboard" replace />} />
                                <Route path="dashboard" element={<DashboardMember />} />
                                <Route path="profil" element={<ProfilPesantren />} />
                                <Route path="unit-usaha" element={<UnitUsaha />} />
                            </Route>
                        </Route>
                    </Route>

                    {/* === AREA ADMIN (PRIVAT) === */}
                    <Route element={<AdminGuard />}>
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<DashboardAdmin />} />
                            <Route path="verifikasi" element={<VerifikasiPendaftaran />} />
                            <Route path="approval" element={<ApprovalFinal />} />
                            <Route path="master-data" element={<MasterData />} />
                            <Route path="pengurus" element={<PengurusAdmin />} /> {/* Rute baru */}
                            <Route path="berita" element={<BeritaAdmin />} />       {/* Rute baru */}
                            <Route path="dokumen" element={<DokumenAdmin />} />     {/* Rute baru */}
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;